import type { ZodType } from 'zod';
import { z } from 'zod';
import type {
  CprOrganisationDto,
  CprOrganisationFilter,
} from '#pie/internal/api/pie-bff';
import { MarketRole } from '#pie/internal/api/pie-bff';
import { getValues } from '#pie/utils/ZodUtils';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprOrganisationFilters = {
  marketPartyIds: [],
  marketRoles: [],
} satisfies z.infer<typeof cprOrganisationFiltersSchema>;

export const cprOrganisationFiltersSchema: ZodType<
  CprOrganisationFilter,
  unknown
> = z
  .object({
    marketPartyIds: z.array(z.string()).optional(),
    marketRoles: z.array(z.enum(getValues(MarketRole))).optional(),
  })
  .catch(defaultCprOrganisationFilters);

export const cprOrganisationFiltersAtom =
  createFiltersAtom<CprOrganisationFilter>({
    defaultFilters: defaultCprOrganisationFilters,
    filtersSchema: cprOrganisationFiltersSchema,
  });

export const defaultCprOrganisationSorting: DefaultSorting<CprOrganisationDto> =
  {
    desc: false,
    id: 'marketParty.name',
  };

export const cprOrganisationSortingAtom = createSortingAtom({
  defaultSorting: defaultCprOrganisationSorting,
});
